module.exports = "/static/assets/00eb9f3a68e7def1267326fb86281a58.png";